/**
 * Modèle PlayerAdventure - Identique à Flutter
 */

import {PlayerStep, PlayerStepFromJson} from './PlayerStep';

export interface PlayerAdventure {
  uniqueURI: string;
  name: string;
  type: string;
  startNumero: number;
  steps: PlayerStep[];
  description?: string;
  cardGFontTitle?: string;
  image?: string; // Base64 encodé
  extraFields?: any[]; // Peut être des objets (value, type) ou des nombres (IDs)
  objects?: number[];
  attributes?: number[];
  isBackupAllowed: boolean;
}

export const PlayerAdventureFromJson = (json: any): PlayerAdventure => {
  const steps = (json.steps as any[] || []).map((step) => {
    return PlayerStepFromJson(step);
  });

  const backupAllowedValue = json.backupAllowed;
  const isBackupAllowed = backupAllowedValue != null ? Boolean(backupAllowedValue) : true;

  return {
    uniqueURI: json.uniqueURI || '',
    name: json.name || '',
    type: json.type || '',
    startNumero: json.startNumero ?? 0,
    steps,
    description: json.description,
    cardGFontTitle: json.cardGFontTitle,
    image: json.image,
    extraFields: json.extraFields as any[] | undefined, // Garder les objets tels quels
    objects: (json.objects as any[])?.map((x) => Number(x)),
    attributes: (json.attributes as any[])?.map((x) => Number(x)),
    isBackupAllowed,
  };
};
